var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalProspectosBalken(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 16.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#efb928;stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24,16.01c0-2.66-2.49-4.84-5.53-4.84h-1.02c-1.41,0-2.7.47-3.68,1.24-1.25-1.46-3.24-2.41-5.47-2.41h-1.44c-3.77,0-6.86,2.7-6.86,6h11.92s0,0,0,0h12.08ZM17.55,12.78h.93c1.28-.03,2.48.57,3.22,1.61h-6.8c-.05-.16-.11-.31-.17-.47.74-.75,1.75-1.17,2.82-1.15ZM6.97,12.01h1.43c1.55-.04,3.02.72,3.9,2H2.97c.92-1.29,2.42-2.04,4-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.96,10.36c1.9.11,3.54-1.32,3.69-3.22v-.81c-.14-1.9-1.78-3.34-3.69-3.22-1.9-.11-3.54,1.32-3.68,3.22v.81c.14,1.9,1.78,3.34,3.68,3.22ZM16.12,6.33c.07-.95.89-1.67,1.84-1.61.95-.06,1.77.66,1.84,1.61v.81c-.07.95-.89,1.67-1.84,1.61-.95.06-1.77-.66-1.84-1.61v-.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8,9.01c2.36.14,4.4-1.64,4.57-4v-1C12.4,1.65,10.36-.13,8,0c-2.36-.14-4.4,1.64-4.57,4v1c.18,2.36,2.21,4.14,4.57,4ZM5.71,4.01c.09-1.18,1.1-2.07,2.28-2,1.18-.07,2.2.82,2.28,2v1c-.09,1.18-1.1,2.07-2.28,2-1.18.07-2.2-.82-2.28-2v-1Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalProspectosBalken);
export default __webpack_public_path__ + "static/media/total_prospectos_BALKEN.9ec5e4d18da0cd4e2834fcf29778cdbe.svg";
export { ForwardRef as ReactComponent };